import { useMutation } from "@tanstack/react-query";
import { API_URL } from "src/Utils/API";
import { BulkCreateRestaurantEntryPayload, BulkCreateResult } from "../types/restaurant";


export const useBulkCreateRestaurants = (onSuccess?: () => void) => {
    return useMutation({
        mutationFn: async (payload: BulkCreateRestaurantEntryPayload[]) => {
            const response = await fetch(`${API_URL}/admin/restaurants/bulk`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const data = await response.json();

            return data as BulkCreateResult;
        },
        onSuccess,
    });
};
